var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundLystIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240.4 242.9",
    style: {
      enableBackground: "new 0 0 240.4 242.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60.2,91.4 160,91.4 127.5,76.8 30.8,76.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.3,20h-169c-12.8,0-23.2,10.4-23.2,23.2v30.3h96.1h72.7c5.7,0,10.8-2,14.9-5.3c1.7-1.4,3.3-3.1,4.5-5 c0.8-1.2,1.6-2.6,2.2-4c1.2-2.8,1.8-5.9,1.8-9.1L216.3,20L216.3,20z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "53.2,166.2 112.8,166.2 88.7,151.5 29.5,151.5  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,193v30H94c0.8,0,1.7,0,2.5-0.1c3.3-0.3,6.3-1.3,9.1-2.8c1.4-0.7,2.7-1.6,3.9-2.6c1.2-1,2.3-2.1,3.3-3.3 s1.9-2.5,2.6-3.9s1.4-2.8,1.8-4.3c0.7-2.3,1.1-4.7,1.1-7.2v-29.2H58.6H47.7C34.7,169.5,24.1,180,24.1,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.1,118.3v29.9h59.2h60.6c1.6,0,3.2-0.2,4.7-0.5c0.8-0.2,1.5-0.3,2.2-0.6c2.2-0.7,4.2-1.7,6.1-2.9 c1.2-0.8,2.4-1.8,3.5-2.8c4.2-4.2,6.8-10,6.8-16.5V94.7H66.8H47.7C34.7,94.7,24.1,105.3,24.1,118.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundLystIcon);
export default __webpack_public_path__ + "static/media/FundLyst-icon.6805ddd1feb1df6a6fa049c3812cedf9.svg";
export { ForwardRef as ReactComponent };